











































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ required: true })
  isDisplayDialog!: boolean;

  @Prop({ default: "headline" })
  cardTitleClass!: string;

  @Prop({ required: false })
  cardContentClass!: string;

  @Prop({ default: true })
  hasSubmit!: boolean;

  @Prop({ default: "Cancel" })
  cancelText!: string;

  @Prop({ default: true })
  hideOnOutsideClick!: boolean;

  @Prop({ default: true })
  hasCancel!: boolean;

  @Prop({ default: false })
  submitDisabled!: boolean;

  @Prop({ default: false })
  submitLoading!: boolean;

  @Prop({ default: "OK" })
  submitText!: string;

  @Prop({ default: 500 })
  maxWidth!: number;

  @Prop({ default: false })
  hasTooltip!: boolean;

  @Prop()
  tooltipMessage!: string;

  @Prop({ type: Boolean })
  scrollable!: boolean;

  @Emit()
  hidePrompt() {
    return !this.isDisplayDialog;
  }

  @Emit()
  submit() {
    return !this.isDisplayDialog;
  }
}
